<template>
  <div>
    <b-button v-b-modal="'buffering-modal-' + company.id" class="p-2 fz-inherit" variant="outline-secondary">
      <div class="d-flex align-items-center">
        <mdicon name="CogOutline" class="color-black mr-2" size="36" />
        <span class="color-black">Settings</span>
      </div>
    </b-button>

    <b-modal :id="'buffering-modal-' + company.id" no-footer centered>
      <template #title> Buffering settings </template>
      <div v-if="bufferingEnabled">
        <div class="form-group mt-3">
          <label :for="`buffering-cutoff-${company.id}`">Cutoff time</label>
          <input
            :id="`buffering-cutoff-${company.id}`"
            v-model="bufferingOptions.cutoffTime"
            type="time"
            class="form-control"
            name="bufferingOptionsCutoffTime"
            placeholder=" "
          />
        </div>

        <div class="form-group mt-3">
          <label :for="`buffering-count-${company.id}`">Item count</label>
          <input
            :id="`buffering-count-${company.id}`"
            v-model="bufferingOptions.itemsCount"
            type="number"
            min="0"
            class="form-control"
            name="bufferingOptionsItemsCount"
            placeholder=" "
          />
        </div>

        <div class="form-group mt-3">
          <label :for="`buffering-minutes-${company.id}`">Minutes after creation</label>
          <input
            :id="`buffering-minutes-${company.id}`"
            v-model="bufferingOptions.minutesDiff"
            type="number"
            min="0"
            class="form-control"
            name="bufferingOptionsMinutesDiff"
            placeholder=" "
          />
        </div>

        <div class="mt-3 text-center">
          <b-button @click="sendRequest"> Save Settings </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import type { BufferingOptions, RequestCompany, Company } from '@/types/Models/Company'
import { notify } from '@kyvg/vue3-notification'
import { BButton, BModal } from 'bootstrap-vue-next'
import { defineComponent, ref, type PropType, type Ref } from 'vue'
import { useCustomersStore } from '@/store/customers'

export default defineComponent({
  name: 'BufferingModal',
  components: { BButton, BModal },
  props: {
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
  },
  setup(props) {
    const customersStore = useCustomersStore()
    const bufferingEnabled: Ref<boolean> = ref(props.company.isBufferingEnabled)
    const bufferingOptions: Ref<BufferingOptions> = ref({
      cutoffTime: props.company.bufferingOptions?.cutoffTime || '',
      itemsCount: props.company.bufferingOptions?.itemsCount || '',
      minutesDiff: props.company.bufferingOptions?.minutesDiff || '',
    })

    const sendRequest = (): void => {
      const data: Partial<RequestCompany> = {
        isBufferingEnabled: bufferingEnabled.value,
        bufferingOptions: bufferingEnabled.value
          ? {
              cutoffTime: bufferingOptions.value.cutoffTime ? bufferingOptions.value.cutoffTime.toString() : null,
              itemsCount: bufferingOptions.value.itemsCount
                ? parseInt(bufferingOptions.value.itemsCount.toString())
                : null,
              minutesDiff: bufferingOptions.value.minutesDiff
                ? parseInt(bufferingOptions.value.minutesDiff.toString())
                : null,
            }
          : null,
      }
      customersStore.update({ id: props.company.id, data }).catch(() => {
        notify({
          group: 'error',
          text: 'Failed to update settings',
        })
      })
    }

    return {
      bufferingEnabled,
      bufferingOptions,
      sendRequest,
    }
  },
})
</script>
